import {Injectable} from '@angular/core';
import {DialogService} from '@npck/libs/ui-kit';
import {Observable} from 'rxjs';
import {ESignDialogComponent, ESignDialogData, ESignDialogResult} from '../components/e-sign-dialog/e-sign-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class ESignDialogService {

    constructor(
        private dialogService: DialogService,
    ) {
    }

    openDialog(data: ESignDialogData): Observable<ESignDialogResult> {
        return this.dialogService.openCustomDialog<ESignDialogComponent, ESignDialogResult>(ESignDialogComponent, data, {
            panelClass: 'mobile-dialog',
        });
    }
}
